// Auth
const AUTH_LOGIN = "/auth/login";
const HOME = "/";

const PROFILE = "/profile";
const USER = "/user";
const REVENUES = '/revenues'
const SYSTEM = '/system'
const SYSTEM_CONFIGURATION = '/system-configuration'
const LIMIT_CHECK_ERR_CODE_PACKAGE = '/limit-check-err-code-package'
const REPORT = '/report'
const SHARKS = "/sharks";
const OVERVIEW = '/overview';
const RETRY = '/retry';
const BANKS = "/banks";
const VOTES = "/votes";
const ADMIN = "/admin";
const ADMIN_EDIT = "/admin/:id";
const STATISTICAL = "/statistical";
const CREATE_STATISTICAL = "/create-statistical";
const EDIT_STATISTICAL = "/edit-statistical";

const ROLES = "/roles";
const ROLE_CREATE = '/roles/create'
const ROLE_EDIT = "/roles/:id";

const DASHBOARD = '/dashboard'

const TRANSACTIONS = "/transactions";
const TRANSACTION_OVERVIEW = '/transaction-overview';
const TRANSACTION_RETRY = '/transaction-retry';

const PACKAGES = "/packages";
const CREATE_PACKAGES_SPONSOR = '/create-packages-sponsor';
const CREATE_PACKAGES_CODE = '/create-packages-code';
const EDIT_PACKAGES_SPONSOR = '/edit-packages-sponsor';
const EDIT_PACKAGES_CODE = '/edit-packages-code';

const PARTNERS = "/partners";
const PARTNER_MANAGEMENT = "/partner-management";
const PACKAGE_MANAGEMENT = "/package-management";
const CREATE_PARTNER_SPONSOR = '/create-partner-sponsor';
const CREATE_PARTNER_CODE = '/create-partner-code';
const CREATE_PARTNER_SPONSOR_PROMOTION = '/create-partner-sponsor-promotion';
const EDIT_PARTNER_SPONSOR = '/edit-partner-sponsor';
const EDIT_PARTNER_SPONSOR_PROMOTION = '/edit-partner-sponsor-promotion';
const EDIT_PARTNER_CODE = '/edit-partner-code';

const ACCOUNT_MANAGEMENT = "/account-management";
const PARTNERS_LIST = "/partners";
const CREATE_PARTNER = "/create-partner";
const EDIT_PARTNER = "/edit-partner";
const PROVIDER_LIST = "/providers";
const CREATE_NETWORK_PROVIDER = "/create-network-provider";
const EDIT_NETWORK_PROVIDER = "/edit-network-provider";
const CREATE_VDS_PROVIDER = "/create-vds-provider";
const EDIT_VDS_PROVIDER = "/edit-vds-provider";
const CREATE_TDM_PROVIDER = "/create-tdm-provider";
const EDIT_TDM_PROVIDER = "/edit-tdm-provider";

const REPORTS_ANALYTICS = "/reports-analytics";
const TRANSACTION_REPORTS = "/transaction-reports";
const AUDIT_TRAIL_EXPORT = "/audit-trail-export";
const DATA_SPONSOR_STATISTICS = "/data-sponsor-statistics";

export {
  AUTH_LOGIN,
  PROFILE,
  HOME,
  USER,
  SHARKS,
  VOTES,
  BANKS,
  ADMIN,
  ADMIN_EDIT,
  ROLES,
  ROLE_CREATE,
  ROLE_EDIT,
  REVENUES,
  OVERVIEW,
  RETRY,
  SYSTEM,
  SYSTEM_CONFIGURATION,
  LIMIT_CHECK_ERR_CODE_PACKAGE,
  REPORT,
  STATISTICAL,
  CREATE_STATISTICAL,
  EDIT_STATISTICAL,

  DASHBOARD,

  TRANSACTIONS,
  TRANSACTION_OVERVIEW,
  TRANSACTION_RETRY,

  PACKAGES,
  CREATE_PACKAGES_SPONSOR,
  CREATE_PACKAGES_CODE,
  EDIT_PACKAGES_SPONSOR,
  EDIT_PACKAGES_CODE,

  PARTNERS,
  PARTNER_MANAGEMENT,
  PACKAGE_MANAGEMENT,
  CREATE_PARTNER_SPONSOR,
  CREATE_PARTNER_SPONSOR_PROMOTION,
  CREATE_PARTNER_CODE,
  EDIT_PARTNER_SPONSOR,
  EDIT_PARTNER_SPONSOR_PROMOTION,
  EDIT_PARTNER_CODE,

  ACCOUNT_MANAGEMENT,
  PARTNERS_LIST,
  CREATE_PARTNER,
  EDIT_PARTNER,
  PROVIDER_LIST,
  CREATE_NETWORK_PROVIDER,
  EDIT_NETWORK_PROVIDER,
  CREATE_VDS_PROVIDER,
  EDIT_VDS_PROVIDER,
  CREATE_TDM_PROVIDER,
  EDIT_TDM_PROVIDER,

  REPORTS_ANALYTICS,
  TRANSACTION_REPORTS,
  AUDIT_TRAIL_EXPORT,
  DATA_SPONSOR_STATISTICS,
};
